import types from '../constants/PlatformActionTypes';

export function updatePlatform(platform) {
  return {
    type: types.UPDATE_PLATFORM,
    platform,
  };
}
